import React from "react";

export const fieldClassName =
  "h-12 w-full rounded-xl border border-slate-200 bg-white px-4 text-sm font-semibold text-slate-800 outline-none transition placeholder:font-normal placeholder:text-slate-400 focus:border-orange-400 focus:ring-4 focus:ring-orange-400/10 dark:border-white/10 dark:bg-slate-800 dark:text-white dark:[color-scheme:dark]";

export default function FormField({
  label,
  hint,
  required = false,
  children,
  className = "",
}) {
  return (
    <label className={`block ${className}`}>
      <span className="mb-2 flex items-center justify-between gap-3">
        <span className="text-sm font-black text-slate-700 dark:text-slate-200">
          {label}

          {required ? (
            <span className="ml-1 text-orange-500">
              *
            </span>
          ) : null}
        </span>

        {hint ? (
          <span className="text-xs text-slate-400">
            {hint}
          </span>
        ) : null}
      </span>

      {children}
    </label>
  );
}